import { render, staticRenderFns } from "./SmediasForm.vue?vue&type=template&id=92f80b72&scoped=true"
import script from "./SmediasForm.vue?vue&type=script&lang=js"
export * from "./SmediasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f80b72",
  null
  
)

export default component.exports